export default "__VITE_ASSET__18938488__"